import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { Tree, Select,Option,Tooltip,Checkbox} from 'element-ui';

Vue.use(Tree);
Vue.use(Select);
Vue.use(Option);
Vue.use(Tooltip);
Vue.use(Checkbox)
import 'leaflet/dist/leaflet.css'
//引入通用css
import commonCss from './css/common.css'
Vue.use(commonCss)
//引入通用js
import utils from './utils/utils';
Vue.prototype.$utils = utils;
//引入axios
import axios from 'axios';
Vue.prototype.axios = axios;
Vue.prototype.$axios = axios;
//axios请求头header传token
axios.interceptors.request.use(function (config) {
  let token = window.localStorage.getItem('authorToken');
  if (token) {
    // 添加headers
    config.headers.authorization = `Bearer ${token}`;
  }
  return config;
}, function (err) {
  return Promise.reject(err);
})
//统一判断所有接口的4000登录超时
axios.interceptors.response.use(data => {
  let code = data.data.status;
  if (code === 4000) {
    //登录超时
    utils.quitLogin();
  }
  return data;//别忘了返回data
}, error => {
  return Promise.reject(error)
})


//引入mapbox
import 'mapbox-gl/dist/mapbox-gl.css'

//引入剪切板
import VueClipboard from "vue-clipboard2";
import exportFunctions from "@/utils/exportFunctions";

Vue.use(VueClipboard);

Vue.use(exportFunctions)

Vue.config.productionTip = false

const toolsFrame = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

window.toolsFrame = toolsFrame